import { gsap, ScrollTrigger } from "../layout";

// swiper
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, Thumbs, EffectFade } from 'swiper/modules';

// matchheight
import {matchHeight} from '../matchHeight';

document.addEventListener('DOMContentLoaded', () => {
    
})

window.addEventListener('resize', () => {
    
})